import styles from './Footer.module.css';
import { FaFacebook, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  const whatsappNumber = '27795957913'; 
  const whatsappLink = `https://wa.me/${whatsappNumber}`;
  const facebookLink = 'https://www.facebook.com/NateAnneDev';

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <h3>Nate~Anne</h3>
        <p>Crafting digital experiences that drive results.</p>
        <div className={styles.socials}>
          <a href={facebookLink} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebook />
          </a>
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <FaWhatsapp />
          </a>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <p>&copy; 2025 Nate~Anne. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;